import { ToastService } from 'src/app/shared/services/toast-service/toast.service';
import { CommonModule } from '@angular/common';
import { GoogleMapsService } from './../../../requests-handling/caregiver-scoreboard/caregiver-selection/caregiver-selection-service/google-maps.service';
import {
  BabysitterState,
  RouterStateManagerService,
} from '../../../shared/services/router-state-manager/router-state-manager.service';
import {
  CaregiverSummary,
  Babysitter,
  ModalService,
} from 'npx-family-happy-common';
import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  input,
  Input,
} from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { BabySitterService } from '../baby-sitter-service/baby-sitter-service.service';
import {
  BehaviorSubject,
  catchError,
  combineLatest,
  debounceTime,
  Subject,
  Subscription,
  takeUntil,
} from 'rxjs';
import { ProvinceService } from 'src/app/shared/services/province-service/province.service';
import { AuthService } from 'src/app/authentication/auth/auth.service';
import {
  ModalDismissReasons,
  NgbActiveModal,
  NgbModal,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { CaregiverSelectionRecordSortable } from 'src/app/shared/models/caregiverSelectionRecordSortable.models';
import { MapComponent } from 'src/app/shared/components/map/map/map.component';
import { AlertComponent } from 'src/app/shared/components/modals/alert/alert.component';
import { InputMapComponent } from 'src/app/shared/components/input-map/input-map.component';
import { RouterModule } from '@angular/router';
import { BabysitterFilterModalComponent } from 'src/app/shared/components/modals/babysitter-filter-modal/babysitter-filter-modal.component';
import { cellFormatter, emailFormatter } from 'src/app/shared/utils.functions';

@Component({
  selector: 'app-baby-sitter-list',
  standalone: true,
  templateUrl: './baby-sitter-list.component.html',
  styleUrls: ['./baby-sitter-list.component.scss'],
  imports: [
    CommonModule,
    MapComponent,
    ReactiveFormsModule,
    AlertComponent,
    InputMapComponent,
    RouterModule,
    NgbTooltipModule,
    BabysitterFilterModalComponent,
  ],
})
export class BabySitterListComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  showAlert = false;
  showMore = false;
  showFilters = false;
  selectedRef = '';
  elementsPerPage = new UntypedFormControl(10);
  showPageButton = true;
  minAge!: number;
  maxAge!: number;
  form = new UntypedFormGroup({
    docRef: new UntypedFormControl(''),
    name: new UntypedFormControl(''),
    email: new UntypedFormControl(''),
    phone: new UntypedFormControl(''),
    fromAge: new UntypedFormControl(null),
    toAge: new UntypedFormControl(null),
    page: new UntypedFormControl(1),
    latitude: new UntypedFormControl(null),
    longitude: new UntypedFormControl(null),
    range: new UntypedFormControl(5),
    /* limit: new FormControl(10) */
  });
  filters: any = {}; //filters of Babysitter filter modal
  filtersObserver = new BehaviorSubject<any>(undefined);
  filtersRecreated = false;
  resetFiltersModal = false;
  babysitters: CaregiverSummary[] = [];
  original: CaregiverSummary[] = [];
  private province = '';
  private subscription!: Subscription;
  private babysitterState!: BabysitterState;
  private subscriptions: Subscription[] = [];
  isAdmin = false;
  unsubscribe = new Subject<void>();
  private closeResult = '';
  toastMessage!: string;

  //MAPS FILTERS
  sortableBB: CaregiverSelectionRecordSortable[] = [];
  address!: any;
  addressInput = new UntypedFormControl('');
  resetChildren = false;

  constructor(
    private babySitterService: BabySitterService,
    private provinceService: ProvinceService,
    private stateManager: RouterStateManagerService,
    private modalService: ModalService,
    private authService: AuthService,
    private googleMapsService: GoogleMapsService,
    private ngbModalService: NgbModal,
    private toastService: ToastService
  ) {
    this.authService
      .getToken()
      .subscribe(
        (token) => (this.isAdmin = this.authService.isUserAdmin(token) ?? false)
      );
  }

  ngOnInit(): void {
    let subscriptions: any = {};
    subscriptions.province = this.provinceService.getProvince().pipe(
      catchError((error) => {
        return error;
      })
    );
    subscriptions.state = this.stateManager.getBabysitterState().pipe(
      catchError((error) => {
        return error;
      })
    );
    this.subscriptions.push(
      combineLatest(subscriptions).subscribe((values: any) => {
        this.province = values.province;
        this.babysitterState = values.state;
        if (!this.babysitterState.filters.province) {
          this.babysitterState.filters.province = '';
        }
        this.babysitterState.filters.page = 1;
        if (Object.keys(this.babysitterState.filters).length > 0) {
          if (this.province !== this.babysitterState.filters.province) {
            this.filters = this.recreateFilterObject(
              this.babysitterState.filters,
              false
            );
          } else {
            this.filters = this.recreateFilterObject(
              this.babysitterState.filters,
              true
            );
          }
          this.babysitterState.filters.province;
          this.filtersObserver.next(this.filters);
          // let inputAddress = document.getElementById('address') as HTMLInputElement;
          // inputAddress.value = ''
          // this.addressInput.setValue('')
          this.form.setValue(
            {
              docRef: this.babysitterState.filters.docRef ?? '',
              name: this.babysitterState.filters.info?.name ?? '',
              email: this.babysitterState.filters.info?.email ?? '',
              phone: this.babysitterState.filters.info?.phone ?? '',
              fromAge: this.babysitterState.filters.fromAge ?? null,
              toAge: this.babysitterState.filters.toAge ?? null,
              page: 1,
              latitude: this.babysitterState.filters.latitude ?? null,
              longitude: this.babysitterState.filters.longitude ?? null,
              range: this.babysitterState.filters.range ?? 10,
            },
            { emitEvent: true }
          );
          this.addressInput.setValue(
            this.babysitterState.filters.address ?? ''
          );
        }
        if (
          Object.keys(this.babysitterState.filters).length === 0 &&
          this.subscription
        ) {
          try {
            this.askMoreBabysitters();
          } catch (err) {
            this.modalService.showErrorMessage(
              'Non è stato possibile caricare i nuovi dati aggiornati.'
            );
          }
        }
        if (!this.subscription) {
          if (this.babysitterState.filters.province === '') {
            this.babysitterState.filters.province = null;
          }
          this.subscription = this.babySitterService
            .getBabySitter(
              this.babysitterState.filters,
              this.elementsPerPage.value
            )
            .subscribe((data) => {
              if (!this.filtersRecreated) {
                this.populateBabysitter(data);
              } else {
                this.filtersRecreated = false;
              }
            });
          this.subscriptions.push(
            this.form.valueChanges
              .pipe(debounceTime(300))
              .subscribe((value) => {
                if (value.page > (this.babysitterState.filters.page ?? 1)) {
                  try {
                    this.askMoreBabysitters();
                  } catch (err) {
                    this.modalService.showErrorMessage(
                      'Non è stato possibile caricare i nuovi dati aggiornati.'
                    );
                  }
                } else {
                  this.babysitters = [];
                  this.page?.setValue(1, { emitEvent: false });
                  try {
                    this.askMoreBabysitters();
                  } catch (err) {
                    this.modalService.showErrorMessage(
                      'Non è stato possibile caricare i nuovi dati aggiornati.'
                    );
                  }
                }
              })
          );
          this.subscriptions.push(
            this.elementsPerPage.valueChanges.subscribe((value) => {
              this.babysitters = [];
              this.babySitterService
                .getBabySitter(this.babysitterState.filters, value)
                .subscribe((bb) => {});
            })
          );
        }
      })
    );
  }

  generateCaregiverListSortable(bb: Babysitter[]) {
    this.sortableBB = [];
    bb.forEach((babysitter) => {
      let bbSortable = {
        fittingIndex: 0,
        record: {
          id: 0,
          requestID: 0,
          babysitter: babysitter,
          petsitter: null,
          nurse: null,
          colf: null,
          nutritionist: null,
          psychologist: null,
          coach: null,
          suitable: false,
          suitableDate: null,
          selected: false,
          selectedDate: null,
          chosen: false,
          chosenDate: null,
          discarded: false,
          discardedDate: null,
          discardedReason: '',
          distance: 0,
          favorite: false,
          cvSent: false,
          cvSentDate: null,
          contactSent: false,
          contactSentDate: null,
        },
      };
      this.sortableBB.push(bbSortable);
    });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subscription.unsubscribe();
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
    this.subscriptions.splice(0, this.subscriptions.length);
    this.stateManager.setBabysitterState(this.babysitterState, false);
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngAfterViewInit(): void {
    /* Google Maps */
    // this.loadGoogleMaps(document.getElementById('address') as HTMLInputElement);
  }

  rowClick(babysitter: any) {
    if (!babysitter) {
      this.babysitterState.id = 'new';
    } else {
      this.babysitterState.id = babysitter.docRef;
    }
    this.babysitterState.route = 'babysitter-detail/' + this.babysitterState.id;
    this.babysitterState.step = 0;
    this.babysitterState.babysitter = undefined;
    this.ngOnDestroy();
    this.stateManager.setBabysitterState(this.babysitterState);
  }

  /* Delete babysitter code */
  deleteBabysitter(docRef: string) {
    this.selectedRef = docRef;
    this.showAlert = true;
  }

  onAlertConfimation(event: boolean) {
    if (event) {
      const index = this.babysitters.findIndex(
        (item) => item.docRef === this.selectedRef
      );
      this.babysitters.splice(index, 1);
      this.original.splice(index, 1);
      this.subscriptions.push(
        this.babySitterService
          .deleteBabySitter(this.selectedRef)
          .subscribe((res: any) => {
            this.modalService.showSuccessMessage(
              'Babysitter eliminata con successo.'
            );
          })
      );
    }
    this.selectedRef = '';
    this.showAlert = false;
  }

  /* Filter management code */
  showFiltersModal() {
    this.showFilters = true;
    this.filtersObserver.next(this.filters);
  }

  resetFilters() {
    this.babysitters = [];
    this.resetFiltersModal = true;
    this.resetChildren = true;
    this.addressInput.reset();
    this.form.reset(
      {
        docRef: '',
        name: '',
        email: '',
        phone: '',
        fromAge: null,
        toAge: null,
        page: 1,
        latitude: null,
        longitude: null,
        range: 10,
      },
      { emitEvent: false }
    );
    // Reset babysitter filter modal filters
    this.filters = undefined;
    this.filtersObserver.next(this.filters);
    this.askMoreBabysitters(true);
  }

  processFilters(reset = false) {
    this.showFilters = false;
    let filters: any = {};
    if (reset) {
      filters = { page: 1 }; // Load all the babysitters
    } else {
      filters.info = {};
      filters.avail = {};
      filters.exp = {};
      filters.lang = {};
      filters.rating = {};
      filters.engagement = {};
      filters.cert = {};
      filters.page = this.page?.value;
      if (this.docRef?.value !== '') {
        filters.docRef = this.docRef?.value;
      }
      if (this.name?.value !== '') {
        if (filters.info) {
          filters.info.name = this.name?.value;
        }
      }
      if (this.email?.value !== '') {
        if (filters.info) {
          let formattedMail = emailFormatter(this.email?.value);
          filters.info.email = formattedMail;
        }
      }
      if (this.phone?.value !== '') {
        if (filters.info) {
          let formattedPhone = cellFormatter(this.phone?.value);
          filters.info.phone = formattedPhone;
        }
      }
      if (this.fromAge?.value || this.toAge?.value) {
        (filters.fromAge = this.fromAge?.value),
          (filters.toAge = this.toAge?.value);
      }
      if (this.latitude !== null) {
        filters.latitude = this.latitude.value;
      }
      if (this.longitude !== null) {
        filters.longitude = this.longitude.value;
      }
      if (this.range !== null) {
        filters.range = this.range.value;
      }
      if (this.addressInput !== null) {
        filters.address = this.addressInput.value;
      }

      if (this.filters) {
        if (this.filters.homework) {
          filters.avail.homework = true;
        }
        if (this.filters.cleaning) {
          filters.avail.cleaning = true;
        }
        if (this.filters.cooking) {
          filters.avail.cooking = true;
        }
        if (this.filters.taxi) {
          filters.avail.taxi = true;
        }
        if (this.filters.licence) {
          filters.avail.licence = true;
        }
        if (this.filters.car) {
          filters.avail.car = true;
        }
        if (this.filters.smoker) {
          filters.avail.smoker = true;
        }
        if (this.filters.greenpass) {
          filters.avail.greenpass = true;
        }
        if (this.filters.disostruzione) {
          filters.cert.disostruzione = true;
        }
        if (this.filters.fhsub) {
          filters.info.fhsub = true;
          filters.info.fhSubManual = true;
        }
        if (this.filters.fullCV) {
          filters.fullCV = true;
        }
        const days = this.babySitterService.fromAvailObjectToString(
          this.filters?.days,
          'days'
        );
        if (days !== '') {
          filters.avail.days = days;
        }
        const hours = this.babySitterService.fromAvailObjectToString(
          this.filters?.hours,
          'hours'
        );
        if (hours !== '') {
          filters.avail.hours = hours;
        }
        const contract = this.babySitterService.fromAvailObjectToString(
          this.filters?.contract,
          'contract'
        );
        if (contract !== '') {
          filters.avail.contract = contract;
        }
        if (this.filters.ref) {
          filters.ref = true;
        }
        if (this.filters.rating) {
          filters.rating.overall = true;
        }
        if (this.filters.ignored) {
          filters.engagement.ignored = true;
        }
        if (this.filters.lang) {
          if (this.filters.lang.english) {
            filters.lang.english = true;
          }
          if (this.filters.lang.french) {
            filters.lang.french = true;
          }
          if (this.filters.lang.german) {
            filters.lang.german = true;
          }
          if (this.filters.lang.italian) {
            filters.lang.italian = true;
          }
          if (this.filters.lang.spanish) {
            filters.lang.spanish = true;
          }

          if (this.filters.lang.englishAdvanced) {
            filters.lang.englishAdvanced = true;
          }
          if (this.filters.lang.frenchAdvanced) {
            filters.lang.frenchAdvanced = true;
          }
          if (this.filters.lang.germanAdvanced) {
            filters.lang.germanAdvanced = true;
          }
          if (this.filters.lang.italianAdvanced) {
            filters.lang.italianAdvanced = true;
          }
          if (this.filters.lang.spanishAdvanced) {
            filters.lang.spanishAdvanced = true;
          }
        }
        if (this.filters.exp) {
          if (this.filters.exp.cluster1) {
            filters.exp.cluster1 = true;
          }
          if (this.filters.exp.cluster2) {
            filters.exp.cluster2 = true;
          }
          if (this.filters.exp.cluster3) {
            filters.exp.cluster3 = true;
          }
          if (this.filters.exp.cluster4) {
            filters.exp.cluster4 = true;
          }
        }
      }
    }
    if (this.province !== '') {
      if (!filters || Object.keys(filters).length === 0) {
        filters = { province: this.province };
      } else {
        filters.province = this.province;
      }
    }
    return filters;
  }

  recreateFilterObject(filters: any, fromRequest: boolean) {
    if (filters) {
      if (fromRequest) {
        this.filtersRecreated = true;
      }
      return {
        page: filters.page ?? 1,
        minAge: this.fromAge?.value ?? null,
        maxAge: this.toAge?.value ?? null,
        homework: filters.avail ? filters.avail.homework === true : false,
        cleaning: filters.avail ? filters.avail.cleaning === true : false,
        cooking: filters.avail ? filters.avail.cooking === true : false,
        taxi: filters.avail ? filters.avail.taxi === true : false,
        licence: filters.avail ? filters.avail.licence === true : false,
        car: filters.avail ? filters.avail.car === true : false,
        smoker: filters.avail ? filters.avail.smoker === true : false,
        greenpass: filters.avail ? filters.avail.greenpass === true : false,
        disostruzione: filters.cert
          ? filters.cert.disostruzione === true
          : false,
        fullCV: filters.fullCV ? filters.fullCV === true : false,
        fhsub: filters.info ? filters.info.fhsub === true : false,
        ref: filters.ref ?? false,
        rating: filters.rating ? filters.rating.overall === true : false,
        ignored: filters.engagement
          ? filters.engagement.ignored === true
          : false,
        days: this.babySitterService.fromStringToAvailObject(
          filters.avail ? (filters.avail.days ? filters.avail.days : '') : '',
          'days'
        ),
        hours: this.babySitterService.fromStringToAvailObject(
          filters.avail ? (filters.avail.hours ? filters.avail.hours : '') : '',
          'hours'
        ),
        contract: this.babySitterService.fromStringToAvailObject(
          filters.avail
            ? filters.avail.contract
              ? filters.avail.contract
              : ''
            : '',
          'contract'
        ),
        lang: {
          english: filters.lang ? filters.lang.english === true : false,
          englishAdvanced: filters.lang
            ? filters.lang.englishAdvanced === true
            : false,
          french: filters.lang ? filters.lang.french === true : false,
          frenchAdvanced: filters.lang
            ? filters.lang.frenchAdvanced === true
            : false,
          german: filters.lang ? filters.lang.german === true : false,
          germanAdvanced: filters.lang
            ? filters.lang.germanAdvanced === true
            : false,
          italian: filters.lang ? filters.lang.italian === true : false,
          italianAdvanced: filters.lang
            ? filters.lang.italianAdvanced === true
            : false,
          spanish: filters.lang ? filters.lang.spanish === true : false,
          spanishAdvanced: filters.lang
            ? filters.lang.spanishAdvanced === true
            : false,
        },
        exp: {
          cluster1: filters.exp ? filters.exp.cluster1 === true : false,
          cluster2: filters.exp ? filters.exp.cluster2 === true : false,
          cluster3: filters.exp ? filters.exp.cluster3 === true : false,
          cluster4: filters.exp ? filters.exp.cluster4 === true : false,
        },
      };
    }
    return undefined;
  }

  askMoreBabysitters(resetFilters = false) {
    const filters = this.processFilters(resetFilters);
    try {
      this.babysitterState.filters = filters;
      this.babySitterService
        .getBabySitter(filters, this.elementsPerPage.value)
        .subscribe((babysitters) => {
          if (babysitters.length < this.elementsPerPage.value) {
            this.showPageButton = false;
          } else {
            this.showPageButton = true;
          }
        });
    } catch (err) {
      this.modalService.showErrorMessage(
        'Non è stato possibile caricare i nuovi dati aggiornati.'
      );
    }
  }

  get docRef() {
    return this.form.get('docRef');
  }

  get name() {
    return this.form.get('name');
  }

  get email() {
    return this.form.get('email');
  }

  get phone() {
    return this.form.get('phone');
  }

  get fromAge() {
    return this.form.get('fromAge');
  }

  get toAge() {
    return this.form.get('toAge');
  }

  get page() {
    return this.form.get('page');
  }
  get latitude() {
    return this.form.get('latitude');
  }
  get longitude() {
    return this.form.get('longitude');
  }
  get range() {
    return this.form.get('range');
  }

  private populateBabysitter(array: Babysitter[]) {
    if (array.length > 0) {
      this.generateCaregiverListSortable(array);
      this.original = array.map((item) => {
        return {
          name: item.info ? item.info.name : '-',
          surname: item.info ? item.info.surname : '-',
          email: item.info ? item.info.email : '-',
          phone: item.info ? item.info.phone : '-',
          docRef: item.docRef,
          cv: item.info.resumeHidden ?? '-',
          video: item.info.video,
          dangerous: item.rating.dangerous,
          creationDate: new Date(),
          rating: item.rating.overall,
          subscription: item.info.subscription,
          manualSubscription: item.info.manualSubscription,
          certificate: item.certificate,
        };
      });
    } else {
      this.generateCaregiverListSortable(array);
      this.original = [];
    }
    //SET COORDINATES PERSISTENCE
    let mapInfo = {
      latitude: this.babysitterState.filters.latitude,
      longitude: this.babysitterState.filters.longitude,
      range: this.babysitterState.filters.range,
      addressName: this.babysitterState.filters.address,
      caregiverList: this.sortableBB,
    };

    this.googleMapsService.setCoordinates(mapInfo);
    this.babysitters.push(...this.original);
  }

  loadMore() {
    this.page?.setValue(this.page.value + 1);
  }

  exportBabysitters() {
    const requestFilters = this.processFilters();
    try {
      this.babySitterService
        .exportBabysittersFromDB(requestFilters)
        .subscribe((blob) => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = 'babysitters.xlsx';
          link.click();
        });
    } catch (err) {
      this.modalService.showErrorMessage(
        `Non è stato possibile completare l'export dei dati, perché mancano non è stato possibile applicare i filtri.`
      );
    }
  }

  //MAPS
  open(content: any) {
    this.ngbModalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return 'by pressing ESC';
      case ModalDismissReasons.BACKDROP_CLICK:
        return 'by clicking on a backdrop';
      default:
        return `with: ${reason}`;
    }
  }

  filterModalClose() {
    this.showFilters = false;
    this.resetChildren = false;
  }

  copyToClipboard(event: any) {
    navigator.clipboard.writeText(event);
    this.toastService.setAction(
      'Dati copiati con successo! Ora puoi incollarli dove vuoi.',
      true
    );
  }

  //SCRIPT --- CONVERT ADDRESSES INTO COORDINATES
  private async convertAddress(array: Babysitter[]) {
    let counterTotal = 0;
    let counterConverted = 0;
    let counterNull = 0;
    for (let i = 0; i < array.length; i++) {
      counterTotal++;
      const BB = array[i];
      const address = BB.info.address;
      const latitude = BB.info.latitude;
      const longitude = BB.info.longitude;
      if (address !== null && address !== '') {
        if (latitude === null && longitude === null) {
          try {
            const res = await this.googleMapsService.getCoordinates(address);
            const lat = res[0].geometry.location.lat();
            const lng = res[0].geometry.location.lng();

            const updatedBB = {
              ...BB,
              info: {
                ...BB.info,
                latitude: lat,
                longitude: lng,
              },
            };
            await this.babySitterService
              .updateBabySitter(updatedBB)
              .pipe(takeUntil(this.unsubscribe))
              .toPromise();
            counterConverted++;

            // delay for each interaction
            await this.delay(1500);
          } catch (err) {
            console.log(err);
          }
        } else {
          console.log('ALREADY COORDINATES', longitude, latitude);
          counterNull++;
        }
      } else {
        console.log('UPDATED BB ADDRESS NULL', address);
        counterNull++;
      }
    }
    console.log(`conversioni totali: ${counterTotal}`);
    console.log(`conversioni fallite (o già con coordinate): ${counterNull}`);
    console.log(`conversioni riuscite: ${counterConverted}`);
  }

  async sendCoordinates(address: any) {
    try {
      if (address !== null && address !== '') {
        const res = await this.googleMapsService.getCoordinates(address);
        let coordinates = {
          lat: res[0].geometry.location.lat(),
          lng: res[0].geometry.location.lng(),
        };
        this.form.get('latitude')?.setValue(coordinates.lat);
        this.form.get('longitude')?.setValue(coordinates.lng);
        this.address = {
          latitude: this.form.get('latitude')?.value,
          longitude: this.form.get('longitude')?.value,
          range: this.form.get('range')?.value,
          addressName: address,
        };
      } else {
        console.log('insert address');
      }
    } catch {
      console.log('error');
    }
  }

  private delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  sendAddress(event: any) {
    this.resetChildren = false;
    this.addressInput.setValue(event);
    this.sendCoordinates(event);
  }
}
